import Image from "next/legacy/image"
import Link from 'next/link'
import React from 'react'
import { BsListStars } from 'react-icons/bs'
import { GiOfficeChair } from 'react-icons/gi'
import * as S from './StyledMobileNavigation'

function MobileNavigation() {
  return (
      (<S.MobileNavigation>
          <Link href="/listings/newest">

              <S.NavItem>
              <S.NavIcon>
                  <BsListStars 
                      color="#125F3F"
                      size="22px"
                  />
              </S.NavIcon>
              <S.NavName>New listings</S.NavName>
              </S.NavItem>

          </Link>
          <S.MobileNavDivider />
          <Link href="/listings/Land">

              <S.NavItem>
              <S.NavIcon>
                  <Image
                      src="/images/newLanding/navigationIcons/Land.svg"
                      width={22}
                      height={22}
                      style={{
                          maxWidth: "100%",
                          height: "auto"
                      }} />
              </S.NavIcon>
              <S.NavName>Land</S.NavName>
              </S.NavItem>

          </Link>
          <Link href="/listings/Multifamily">

              <S.NavItem>
              <S.NavIcon>
                  <Image
                      src="/images/newLanding/navigationIcons/Multifamily.svg"
                      width={22}
                      height={22}
                      style={{
                          maxWidth: "100%",
                          height: "auto"
                      }} />
              </S.NavIcon>
              <S.NavName>Multifamily</S.NavName>
              </S.NavItem>

          </Link>
          <Link href="/listings/Retail">

              <S.NavItem>
              <S.NavIcon>
                  <Image
                      src="/images/newLanding/navigationIcons/Retail.svg"
                      width={22}
                      height={22}
                      style={{
                          maxWidth: "100%",
                          height: "auto"
                      }} />
              </S.NavIcon>
              <S.NavName>Retail</S.NavName>
              </S.NavItem>

          </Link>
          <Link href="/listings/Sale-of-Business">

              <S.NavItem>
              <S.NavIcon>
                  <Image
                      src="/images/newLanding/navigationIcons/Business.svg"
                      width={22}
                      height={22}
                      style={{
                          maxWidth: "100%",
                          height: "auto"
                      }} />
              </S.NavIcon>
              <S.NavName>Business</S.NavName>
              </S.NavItem>

          </Link>
          <Link href="/listings/Industrial">

              <S.NavItem>
              <S.NavIcon>
                  <Image
                      src="/images/newLanding/navigationIcons/Industrial.svg"
                      width={22}
                      height={22}
                      style={{
                          maxWidth: "100%",
                          height: "auto"
                      }} />
              </S.NavIcon>
              <S.NavName>Industrial</S.NavName>
              </S.NavItem>

          </Link>
          <Link href="/listings/Office">

              <S.NavItem>
              <S.NavIcon>
                  <GiOfficeChair
                  color="#125F3F"
                  width={22}
                  height={22}
                  />
              </S.NavIcon>
              <S.NavName>Office</S.NavName>
              </S.NavItem>

          </Link>
      </S.MobileNavigation>)
  );
}

export default MobileNavigation
